import React, { useState, useEffect, useContext } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import LinearProgress from "@mui/material/LinearProgress";
import { format, parseISO } from "date-fns";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import "../Holdings/Holdings.css";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import animation from "../../../../images/jm-animation.gif";
function Holdings(props) {
  const [data, setData] = useState([]);
  const [dataPop, setDataPop] = useState([]);
  const [value, setValue] = useState("");
  const [valueSec, setValueSec] = useState([]);
  const [dataSec, setDataSec] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let getSchemeCodeIn = props.getSchemeCode;

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetFundHoldings", {
      IVSchemeCode: getSchemeCodeIn,
      IVSector: value,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
        // console.log(DecryptAESdata(data.data))
      }
    });
    GetPostMethodData(BaseURL + "GetSectorDropDown", {
      IVSchemeCode: getSchemeCodeIn,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setDataSec(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL, value]);

  function getDistinctValuesAsDict(list, key) {
    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }

  // File Edit Selection View Go Run Terminal Help Login MediaCenter ModelCenter RollingReturns Holding FundSummary HistoricalReturn PortfolioDebt MaturityProfile ProductBanner ProductFaq Prod

  return (
    <>
      {/* <div>
                {data && getDistinctValuesAsDict(data, "RepDate").map(({ RepDate, index }) => (
                    <p key={index} className="text-left DateAson"><span className="text-bold">Data as on :</span>{(RepDate != null) ? (format(parseISO(RepDate), 'dd-MMM-yyyy')) : ''}</p>
                ))}
            </div> */}
      <div className="gradiant-head-box">
        <div className="gradiant-head-container p-relative">
          <div className="DateAsOnDiv">
            {data &&
              getDistinctValuesAsDict(data, "AsonDate").map(
                ({ AsonDate, index }) => (
                  <p key={index} className="text-left DateAson">
                    <span>As on - </span>
                    {AsonDate != null
                      ? format(parseISO(AsonDate), "do MMM, yyyy")
                      : ""}
                  </p>
                ),
              )}
          </div>
          <h3 className="gradiant-head left">Holdings</h3>

          <div className="form-group">
            <div className="select-container selectCardPro">
              {data && (
                <>
                <label
                  htmlFor={`holdings-fund-select-${getSchemeCodeIn}`}
                  className="sr-only"
                >
                  Select holding sector
                </label>

                <select
                  name="fund"
                  autoComplete="off"
                  id={`holdings-fund-select-${getSchemeCodeIn}`}
                  //  aria-label="Select holding sector"
                  className="data-selector"
                  onChange={(event) => setValue(event.target.value)}
                >
                  {data && <option value="">Top 5 Holdings</option>}
                  {dataSec && dataSec.length === 0 ? (
                    <h6 className="errorMsg">No Data Found !!!</h6>
                  ) : (
                    ""
                  )}
                  {dataSec &&
                    dataSec.map(({ Sector }) => (
                      <option value={Sector} selected={value === Sector}>
                        {" "}
                        {Sector}{" "}
                      </option>
                    ))}
                </select>
                
                </>
              )}
              {data && <i className="fa fa-caret-down"></i>}
            </div>
          </div>
        </div>
        <div className="gradiant-content">
          <div
            className="padding-box-inner HoldingFund"
            style={{ position: "relative" }}
          >
            <div className="img-container">
              {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
              {loadingshow ? (
                <div className="textcentervertex HomeLoader">
                  <img src={animation} alt="Loading" />
                  <div className="model_popup">Please Wait...</div>
                </div>
              ) : (
                <div>
                  {data == null ? (
                    <h6
                      style={{
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "bold",
                        position: "absolute",
                        top: "45%",
                        // left : "16%"
                      }}
                    >
                      Since this is a new scheme, Holdings data is not yet
                      available
                    </h6>
                  ) : (
                    <>
                      {data &&
                        data.map((item, index) => (
                          <>
                            {index < 5 ? (
                              <>
                                <div class="d-flex justify-content-between mb-1">
                                  <p class="holding-progress-text pr-sm-4">
                                    {item.IssuerLongName}
                                  </p>
                                  <p class="holding-progress-text percentHolding">
                                    {Number(item.PercentToAss).toLocaleString(
                                      "en-IN",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    )}
                                    %
                                  </p>
                                </div>
                                <LinearProgress
                                  variant="determinate"
                                  value={item.PercentToAss}
                                  aria-label={`${item.IssuerLongName} holding ${item.PercentToAss}%`}
                                />
                                <br></br>
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                    </>
                  )}
                </div>
              )}
            </div>
            {/* {loadingshow ? <div className="textcentervertex">
                            <img src={animation} alt="Loading" />
                            <div className="model_popup">Please Wait...</div>
                        </div> : ""
                        } */}
            {/* {data && <a className="product_link" onClick={handleShow}>See All {data && data.length} Holdings</a>} */}
            {data && (
              <button className="product_link" onClick={handleShow}>
                See All Holdings
              </button>
            )}
            <Modal show={show} className="modal productModal modalboxone">
              <Modal.Body>
                <div className="btnDiv">
                  <div onClick={handleClose}>
                    <AiFillCloseCircle className="btncl" />
                  </div>
                </div>
                <div className="bodyModalProduct">
                  {/* <div className="divHoldings">
                                        <div>
                                            {data && <h4 className="fundNameHold">{(data && data[0] != undefined) ? data[0].FundName : '--'}</h4>}
                                        </div>
                                        <div className="select-container">
                                            <select name="fund" id="fund" className="data-selector" onChange={(event) => setValue(event.target.value)} >
                                                <option value="">All Holdings</option>
                                                {dataSec && dataSec.map(
                                                    ({ Sector }) => (
                                                        <option value={Sector} selected={value === Sector}> {Sector} </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    </div> */}

                  <div className="divHoldings">
                    <div>
                      <h4 className="fundNameHold">
                        {data && data[0] ? data[0].FundName : "--"}
                      </h4>
                    </div>
                    <div className="select-container">
                      <select
                        name="fund"
                        id="fund"
                        className="data-selector"
                        autoComplete="off"
                        onChange={(event) => setValue(event.target.value)}
                        value={value} 
                      >
                        <option value="">All Holdings</option>
                        {Array.isArray(dataSec) &&
                          dataSec.length > 0 &&
                          dataSec.map(({ Sector }, index) => (
                            <option key={index} value={Sector}>
                              {Sector}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  {data && data.length === 0 ? (
                    <h6 className="errorMsg">No Data Found !!!</h6>
                  ) : (
                    ""
                  )}
                  {data &&
                    data.map(({ IssuerLongName, PercentToAss }) => (
                      <>
                        <div class="d-flex justify-content-between mb-1">
                          <p class="holding-progress-text pr-sm-4 PopupProduct">
                            {IssuerLongName}
                          </p>
                          <p class="holding-progress-text percentHolding PopupProduct">
                            {Number(PercentToAss).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                            %
                          </p>
                        </div>
                        <LinearProgress
                          variant="determinate"
                          value={PercentToAss}
                        />
                        <br></br>
                      </>
                    ))}
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
}

export default Holdings;
